<template>
	<!-- 头部整体盒子 -->
	<div id="header" class="container-fuild">
		<!-- 电脑导航 -->
		<div class="header-nav hidden-xs">
			<!-- 导航logo -->
			<div class="header-nav-logo container">
				<div class="left">
					<img src="@/assets/images/logo.png">
				</div>
				<div class="right">
					<div class="email">
						<div class="avatar">
							<img src="@/assets/images/img_service.png" />
						</div>
						<div class="contact">
							<div>E-mail contact</div>
							<div>business@colofoo.com</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 导航内容 -->
			<div class="header-nav-box">
				<ul class="header-nav-wrapper container">
					<li
						v-for="(item,index) in navList"
						:key="index"
						:class="index===navIndex?'active':''"
						@click="navClick(index,item.name)"
					>
						<router-link :to="item.path">
							{{ item.name }}
							<span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
						</router-link>
						<dl v-if="item.children.length>0">
							<dt v-for="(i,n) in item.children" :key="n">
								<router-link :to="i.path">{{ i.name }}</router-link>
							</dt>
						</dl>
					</li>
				</ul>
			</div>
		</div>
		<!-- 手机导航 -->
		<div class="header-nav-m container-fuild visible-xs">
			<div class="header-nav-m-logo">
				<img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
			</div>
			<!-- 导航栏 -->
			<div class="header-nav-m-menu text-center">
				{{ menuName }}
				<div
					class="header-nav-m-menu-wrapper"
					data-toggle="collapse"
					data-target="#menu"
					@click="menuClick"
				>
					<span :class="menuClass"></span>
				</div>
				<!-- 导航内容 -->
				<ul id="menu" class="header-nav-m-wrapper collapse">
					<li
						v-for="(item,index) in navList"
						:key="index"
						:class="index===navIndex?'active':''"
						@click="navClick(index,item.name)"
						data-toggle="collapse"
						data-target="#menu"
					>
						<router-link :to="item.path" :title="item.name">
							{{ item.name }}
							<i class="underline"></i>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Header",
	data() {
		return {
			navIndex: sessionStorage.getItem('navIndex') ? Number(sessionStorage.getItem('navIndex')) : 0,
			menuName: sessionStorage.getItem('navName') ? sessionStorage.getItem('navName') : "HOME",
			menuClass: "glyphicon glyphicon-menu-down",
			navList: [
				{
					name: "Home",
					path: "/",
					children: []
				},
				{
					name: "Products",
					path: "/products",
					children: []
				},
				{
					name: "Customized service",
					path: "/customizable",
					children: []
				}
			]
		};
	},
	methods: {
		navClick(index, name) {
			this.navIndex = index
			this.menuName = name
			sessionStorage.setItem('navIndex', index)
			sessionStorage.setItem('navName', name)
		},

		menuClick() {
			if (this.menuClass === "glyphicon glyphicon-menu-down") {
				this.menuClass = "glyphicon glyphicon-menu-up";
			} else {
				this.menuClass = "glyphicon glyphicon-menu-down";
			}
		}
	}
};
</script>
<style lang="less" scoped>
/* 顶部 */
#header {
	transition: all ease 0.6s;
	.header-nav {
		.header-nav-logo {
			display: flex;
			align-items: center;
			padding: 20px 0;
			.left{
				img{
					height: 52px;
				}
			}
			.right{
				margin-left: auto;
				.email{
					display: flex;
					align-items: center;
					.avatar{
						height: 56px;
						img{
							height: 56px;
						}
					}
					.contact{
						margin-left: 20px;
						div:nth-child(1){
							font-size: 16px;
							font-weight: 400;
							color: #FFFFFF;
							line-height: 22px;
						}
						div:nth-child(2){
							font-size: 30px;
							color: #FFFFFF;
							line-height: 42px;
							background: linear-gradient(104deg, #4BE061 0%, #A9E483 100%);
							-webkit-background-clip: text;
							-webkit-text-fill-color: transparent;
						}
					}
				}
			}
		}
		.header-nav-box{
			height: 66px;
			line-height: 66px;
			margin: 0;
			background: #0D132A;
		}
		.header-nav-wrapper {
			> li {
				float: left;
				padding: 0 30px;
				position: relative;
				> a {
					color: #FFFFFF;
					font-size: 0.94rem;
					font-weight: bold;
					padding: 0.9375rem 0;
					position: relative;
					text-decoration: none;
					> span {
						font-size: 0.75rem;
						transition: transform ease 0.5s;
					}
				}
				> dl {
					display: none;
					position: absolute;
					width: 10.5rem;
					top: 80%;
					left: 0;
					z-index: 999999;
					box-shadow: 0 0 3px 1px #ccc;
					background: #fff;
					> dt {
						width: 100%;
						padding: 0.625rem;
						border-bottom: 1px solid #ccc;
						> a:hover {
							text-decoration: none;
						}
					}
					> dt:hover {
						cursor: pointer;
						background: #ccc;
					}
				}
			}
			.active{
				background: linear-gradient(125deg, #430DFF 0%, #8D3EFF 100%);
			}
			> li:hover dl {
				display: block;
			}
		}
	}
	.header-nav-fixed{
		.header-nav-wrapper {
			line-height: 3.125rem;
		}
	}
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
	#header {
		.header-nav-m {
			position: relative;
			.header-nav-m-logo {
				height: 6rem;
				position: relative;
				img {
					height: 5rem;
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					margin: auto;
				}
			}
			.header-nav-m-menu {
				color: #fff;
				height: 4.125rem;
				font-size: 1.55rem;
				line-height: 4.125rem;
				background: #474747;
				position: relative;
			}
			.header-nav-m-menu-wrapper {
				position: absolute;
				top: 50%;
				right: 1.25rem;
				margin-top: -1.5rem;
				width: 3.125rem;
				height: 2.5rem;
				color: #fff;
				z-index: 999999;
				font-size: 0.75rem;
			}
			.header-nav-m-wrapper {
				position: absolute;
				top: 3.125rem;
				left: 0;
				width: 100%;
				background: #474747;
				z-index: 9999999;
				> li {
					height: 4rem;
					line-height: 4rem;
					border-bottom: 1px solid #ccc;
					> a {
						color: #fff;
						font-size: 0.9375rem;
						font-weight: bold;
						padding: 0.9375rem 0;
						position: relative;
						> span {
							font-size: 0.625rem;
						}
					}
				}
			}
		}
	}
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
	#header{
		.header-nav {
			height: 10rem;
			.header-nav-logo {
				img {
					height: 5rem;
				}
			}
			.header-nav-wrapper{
				line-height: 10rem;
				li{
					margin: 0 1.2rem;
					a{
						font-size: 1.2rem;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue